var _circle, _path, _path2, _path3, _path4, _path5, _circle2, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKybImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24,
    fill: "#1BABE2",
    stroke: "#1BABE2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 25H27V26.5H31V25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 28H27V29.5H31V28Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33 20H28V17C28 15.9 27.1 15 26 15H24C22.9 15 22 15.9 22 17V20H17C15.9 20 15 20.9 15 22V33C15 34.1 15.9 35 17 35H33C34.1 35 35 34.1 35 33V22C35 20.9 34.1 20 33 20ZM24 20V17H26V20V22H24V20ZM33 33H17V22H22C22 23.1 22.9 24 24 24H26C27.1 24 28 23.1 28 22H33V33Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28C22.8284 28 23.5 27.3284 23.5 26.5C23.5 25.6716 22.8284 25 22 25C21.1716 25 20.5 25.6716 20.5 26.5C20.5 27.3284 21.1716 28 22 28Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.08 29.18C23.44 28.9 22.74 28.75 22 28.75C21.26 28.75 20.56 28.9 19.92 29.18C19.36 29.42 19 29.96 19 30.57V31H25V30.57C25 29.96 24.64 29.42 24.08 29.18Z",
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 41,
    r: 12,
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 31C34.275 31 30 35.275 30 40.5C30 45.725 34.275 50 39.5 50C44.725 50 49 45.725 49 40.5C49 35.275 44.725 31 39.5 31ZM44.82 37.84L38.455 44.205C38.36 44.3 38.17 44.395 37.98 44.395C37.79 44.395 37.6 44.3 37.41 44.205L34.56 41.355C34.275 41.07 34.275 40.595 34.56 40.31C34.845 40.025 35.32 40.025 35.605 40.31L37.98 42.685L43.775 36.89C44.06 36.605 44.535 36.605 44.82 36.89C45.105 37.175 45.105 37.555 44.82 37.84Z",
    fill: "#98CD6C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKybImage);
export default __webpack_public_path__ + "static/media/kybImage.234c91ff.svg";
export { ForwardRef as ReactComponent };